import React, { Component } from 'react'
import { Button } from 'rmwc/Button';
import centaLogo from '../assets/images/mycentabgwhite.png';


class TopBarLoggedIn extends Component {
  render() {
    return (
    <div className="mdc-toolbar mdc-toolbar--fixed topbar-background">

      <div className="mdc-toolbar__row">

        <section className="mdc-toolbar__section mdc-toolbar__section--align-start">
          {/*<a href="#" id ="demo-menu" className="material-icons mdc-toolbar__menu-icon" onClick= {function(evt){
            evt.preventDefault();
            var drawer = new window.mdc.drawer.MDCTemporaryDrawer(document.getElementById("demo-drawer"));
            drawer.open = true;
          }}>menu</a>*/}
          <i onClick={this.props.toggleSidebar} className="material-icons mdc-top-app-bar__navigation-icon mdc-ripple-upgraded--unbounded mdc-ripple-upgraded topbar-menu">menu</i>
          <img src={centaLogo} alt="logo" className="topbar-logo" />    
          
        </section>
      </div>
    </div>

    )
  }
}
export default TopBarLoggedIn



// WEBPACK FOOTER //
// ./src/layout/TopBarLoggedIn.jsx